import { IHomeMenuItem } from 'components/Header/data'
import { MODAL_ROUTE_URLS } from 'router/modalRoutes'
import { ROUTE_URLS } from 'router/routes'

import { localeCommonKeysType } from 'shared/locale/en-US'
import { UpgamingSportPages } from 'shared/models/Upgaming'
import sport from 'components/Header/img/sport.png'

export type IFooterSubItem = {
  route: string
  mobileRoute?: string
  textID: localeCommonKeysType
}
export interface IFooterItem {
  route: string
  mobileRoute?: string
  textID: Union<localeCommonKeysType, string>
  needAuth?: boolean
  isModal?: boolean
  subItems?: IFooterSubItem[]
  refRoutes?: string[]
}

export const footerLinks: IHomeMenuItem[] = [
  {
    route: MODAL_ROUTE_URLS.CHOOSE_SPORT('sport'),
    textID: 'sport',
    isModal: true,
    refRoutes: [
      ROUTE_URLS.DIGITAIN_SPORT_PAGE('Home'),
      ROUTE_URLS.BETBY_SPORT(),
      ROUTE_URLS.UPGAMING_SPORT_PAGE(UpgamingSportPages.HOME),
    ],
    subItems: [
      {
        textID: 'digitain',
        route: ROUTE_URLS.DIGITAIN_SPORT_PAGE('Home'),
        icon: sport,
      },
      {
        textID: 'betby',
        route: ROUTE_URLS.BETBY_SPORT(),
        icon: sport,
      },
      {
        textID: 'upgaming',
        route: ROUTE_URLS.UPGAMING_SPORT_PAGE(UpgamingSportPages.HOME),
        icon: sport,
      },
    ],
  },
  {
    route: MODAL_ROUTE_URLS.CHOOSE_SPORT('liveSport'),
    textID: 'liveSport',
    isModal: true,
    refRoutes: [
      ROUTE_URLS.DIGITAIN_SPORT_PAGE('Overview'),
      ROUTE_URLS.BETBY_SPORT('live'),
      ROUTE_URLS.UPGAMING_SPORT_PAGE(UpgamingSportPages.LIVE),
    ],
    subItems: [
      {
        textID: 'liveSport1',
        route: ROUTE_URLS.DIGITAIN_SPORT_PAGE('Overview'),
        mobileRoute: ROUTE_URLS.DIGITAIN_SPORT_PAGE('Live'),
        icon: sport,
      },
      {
        textID: 'liveSport2',
        route: ROUTE_URLS.BETBY_SPORT('live'),
        icon: sport,
      },
      {
        textID: 'liveSport3',
        route: ROUTE_URLS.UPGAMING_SPORT_PAGE(UpgamingSportPages.LIVE),
        icon: sport,
      },
    ],
  },
  {
    route: ROUTE_URLS.SLOTS_CASINO(),
    textID: 'casino',
  },
  {
    route: ROUTE_URLS.LIVECASINO(),
    textID: 'liveCasino',
  },
  {
    route: ROUTE_URLS.SLOTS_PROVIDER('otc', 'aviator_spribe'),
    textID: 'aviator',
    authRequired: true,
  },
  {
    route: ROUTE_URLS.TERMSANDCONDITIONS_POINT('generalTerms'),
    textID: 'termsAndConditions',
  },
]
